import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Service from "../../services/KotaService";
import {message} from "antd";

export const initialState = {
    loading: false,
    data: [],
    dataByIDKota:[],
    dataByIDPropinsi:[],
    showMessage:false,
    message:''
}


export const getDataKota = createAsyncThunk('ref/kota',async (data, { rejectWithValue }) => {
    try {
        const response = await Service.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataKotaByIDKota = createAsyncThunk('ref/kotabyidkota',async (data, { rejectWithValue }) => {
    const {token,id_kota}=data;
    try {
        const response = await Service.getDataByID(token,id_kota)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataKotaByIDPropinsi = createAsyncThunk('ref/kotabyidpropinsi',async (data, { rejectWithValue }) => {
    const {token,id}=data;
    try {
        const response = await Service.getDataByIDPropinsi(token,id)
        //console.log(JSON.stringify(response))
        return response;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const kotaSlice = createSlice({
    name: 'kota',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.data = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataKota.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
            })
            .addCase(getDataKota.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataKota.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.data = action.payload
            })
            .addCase(getDataKotaByIDKota.fulfilled, (state, action) => {
                state.loading = false
                state.dataByIDKota = action.payload
            })
            .addCase(getDataKotaByIDKota.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataKotaByIDKota.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataByIDKota = action.payload
            })
            .addCase(getDataKotaByIDPropinsi.fulfilled, (state, action) => {
                state.loading = false
                state.dataByIDPropinsi = action.payload
            })
            .addCase(getDataKotaByIDPropinsi.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataKotaByIDPropinsi.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataByIDPropinsi = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = kotaSlice.actions

export default kotaSlice.reducer
